export default {
  notFoundComponent: {
    pageNotFound: 'Page not found :-(',
    tryToSearch: 'Try to search the content'
  }
}
